<template>
  <div class="evaluation_list_page-root org_evaluation_list-root">
    <div class="main-content-wrap">
      <div class="left-wrap">
        <div class="icon" style="margin-bottom: 10px;cursor:pointer;display: flex;align-items: center;margin-right:105px" @click="goBack">
          <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
          <span style="margin-left:5px">返回</span>
        </div>
        <img class="traing-logo" :src="orgInfo.profile_picture" @error="logoImgLoadErr">
        <p class="traing-name text-line">{{orgInfo.org_name}}</p>
        <p class="traing-num text-line">未调查数量：{{orgInfo.eva_status_N}}</p>
        <p class="traing-num text-line">已调查数量：{{orgInfo.eva_status_Y}}</p>
      </div>
      <div class="right-wrap">
        <div class="content-header">
          <span class="title">请根据中国足协要求，依据实际情况认真填写问卷调查~</span>
        </div>
        <yioks-evaluat-search
          class="search-wrap"
          :search-data='searchData'
          @levelChange='levelChange'
          @dateChange='dateChange'
          @statusChange='statusChange'
          @keywordsChange='keywordsChange($event)'
          @hideIcon='hideIconReq($event)'
          @search='searchList'
        ></yioks-evaluat-search>
        <template v-show="!isEmpty">
          <div class="list-wrap">
            <yioks-loading v-show="isLoading"></yioks-loading>
            <div class="scroll-wrap" v-show="!isLoading">
              <vue-scroll :ops="$options._myOpt.vuescrollOpt" ref="vs">
                <ul class="list-content">
                  <yioks-class-info
                    class="traing-wrap"
                    v-for="(traing) in trainingList"
                    :key="traing.c_id"
                    :traing="traing"
                  >
                    <!-- 2023.03.27修改，宋明昊说 2023.03.01之前的培训班 不让写调查了 -->
                    <div class="btn-wrap" v-if="traing.start_date > '1677600000000'">
                      <button
                        class="btn zuxie-btn zuxie-btn-err"
                        type="buttom"
                        @click="createEvaluat(traing)"
                        v-if="traing.status === $options._myOpt.notEvalua"
                      >开始</button>
                      <button
                        class="btn zuxie-btn"
                        type="buttom"
                        @click="lookEvaluat(traing)"
                        v-else
                      >查看</button>
                    </div>
                    <div class="btn-wrap" v-else>
                      <button
                        class="btn zuxie-btn"
                        type="buttom"
                        @click="lookEvaluat(traing)"
                        v-if="traing.status === 'IsEvalua'"
                      >查看</button>
                    </div>
                  </yioks-class-info>
                </ul>
              </vue-scroll>
            </div>
          </div>
          <div class="pagation-wrap">
            <yioks-paging :paging="paging" @goto-page="gotoPage($event)"></yioks-paging>
          </div>
        </template>
        <yioks-empty class="empty-box" h="auto" v-show="isEmpty"></yioks-empty>
      </div>
    </div>
  </div>
</template>

<script>
import EvaluationList from '@/minix/EvaluationList'
import { correctStatus } from "@/assets/js/apiStatus";
import { getRatingList } from "@/api/agency/agency";
import chinaAssImg from "@/assets/images/org_logo.png";
const HOSTURL = process.env.VUE_APP_URL;

export default {
  name: "OrgEvaluationList",
  mixins: [EvaluationList],
  created() {
  
  },
  data() {
    return {
      trainingList: [],
      orgInfo: {},
    };
  },
  methods: {
    logoImgLoadErr() {
      this.orgInfo.profile_picture = chinaAssImg;
    },
    lookEvaluat(item) {
      this.$router.push({
        name: "OrgShowEvalua",
        params: { classId: item.c_id }
      });
    },
    createEvaluat(item) {
      this.$router.push({
        name: "OrgCreateEvaluation",
        params: { classId: item.c_id }
      });
    },
    ratingList() {
      this.isEmpty = false;
      this.isLoading = true;
      getRatingList({
        page: this.thePage,
        create_time: this.searchData.date,
        eva_status: this.searchData.status,
        keywords: this.searchData.keywords,
        class_level: this.searchData.class_level,
      })
        .then(({ data }) => {
          this.isLoading = false;
          if (data.status === correctStatus) {
            const { page, list, organization } = data.result;
            this.orgInfo = {
              ...organization,
              profile_picture: organization.profile_picture
                ? HOSTURL + organization.profile_picture
                : ""
            };
            this.trainingList = list.map(item => ({
              // ...item, // 如果班级列表出现显示信息错误，请打开这一项，避免再出现这栋低级的错误，一下代码真的low
              c_id: item.c_id,
              periods: item.periods,
              is_special_train: item.is_special_train,
              class_level: item.class_level,
              status: item.eva_id === null ? "NotEvalua" : "IsEvalua",
              name: item.class_name,
              start_date: item.start_date,
              end_date: item.end_date,
              teacher_names: item.teacher_names,
              class_train_type: item.class_train_type,
              moment_picture: item.picture_address
                ? HOSTURL + item.picture_address
                : ""
            }));
            this.paging.prePage = page.page_size;
            this.paging.total = page.total_row;
            this.paging.start = (this.thePage - 1) * this.paging.prePage;
            this.$refs['vs'].scrollTo({ y: 0 });
          } else {
          }
          this.isEmpty = this.trainingList.length <= 0;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="stylus">
@import '~@/assets/css/evaluatList'

</style>
